
export function coachType(el, val, loop) {
	if (val.length > 0) {
		const chkAC = ((val.indexOf(loop.indexOf(loop[0])) >= 0 && val.indexOf(loop.indexOf(loop[1])) >= 0) || (val.indexOf(loop.indexOf(loop[0])) === -1 && val.indexOf(loop.indexOf(loop[1])) === -1)) ? true : checkAC(el, val, loop);
		const chkSeater = ((val.indexOf(loop.indexOf(loop[2])) >= 0 && val.indexOf(loop.indexOf(loop[3])) >= 0) || (val.indexOf(loop.indexOf(loop[2])) === -1 && val.indexOf(loop.indexOf(loop[3])) === -1)) ? true : checkSeater(el, val, loop);
		const chkVolvo = ((val.indexOf(loop.indexOf(loop[4])) >= 0 && val.indexOf(loop.indexOf(loop[5])) >= 0) || (val.indexOf(loop.indexOf(loop[4])) === -1 && val.indexOf(loop.indexOf(loop[5])) === -1)) ? true : checkVolvo(el, val, loop);

		if (chkSeater && chkAC && chkVolvo) {
			return true;
		} else {
			return false;
		}
	}
	return true;
}

export function timeFilter(el, val) {
	if (val.length > 0) {
		let departureTime = el.DepartureTime.split(/[^0-9]/);
		const temp = new Date (departureTime[0],departureTime[1]-1,departureTime[2],departureTime[3],departureTime[4],departureTime[5] );

		if (val.indexOf(0) >= 0 && temp.getHours() >= 0 && temp.getHours() < 6) {
			return true;
		}
		if (val.indexOf(1) >= 0 && temp.getHours() >= 6 && temp.getHours() < 12) {
			return true;
		}
		if (val.indexOf(2) >= 0 && temp.getHours() >= 12 && temp.getHours() < 18) {
			return true;
		}
		if (val.indexOf(3) >= 0 && temp.getHours() >= 18 && temp.getHours() < 24) {
			return true;
		}
		return false;
	}
	return true;
}

export function amenFilter(el, val, amenArr) {
  	if (val.length > 0) {
    	let isAmen = false;
	    if (el.AmenitiesType.length > 0) {
	      	val.forEach((value, index) => {
	            isAmen = el.AmenitiesType.indexOf(value) >= 0 ? (index === 0 ? true : isAmen && true) : false;
	        })
	    }
	    if (isAmen) {
	        return true;
	    } else {
	      return false;
	    }
  	}
  	return true;
}

function checkSeater(el, val, loop) {
	const seater = el.HasSeater;
	// const sleeper = el.HasSeater;
	if (val.indexOf(loop.indexOf(loop[2])) >= 0) {
		return seater;
	} else {
		return !seater;
	}
}

function checkAC(el, val, loop) {
	const ac = el.HasAC;
	if (val.indexOf(loop.indexOf(loop[0])) >= 0) {
		return ac;
	} else {
		return !ac;
	}
}

function checkVolvo(el, val, loop) {
	const volvo = el.BusType.indexOf('volvo') >= 0;
	if (val.indexOf(loop.indexOf(loop[4])) >= 0) {
		return volvo;
	} else {
		return !volvo;
	}
}


// WEBPACK FOOTER //
// ./src/common/filters.js